// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__AMADn","next":"pagination_next__93zT6","prev":"pagination_prev__NN1Eg","disabled":"pagination_disabled__FuxFN","active":"pagination_active__g1ZAS"};